module.exports = __webpack_public_path__ + "img/border_invertedTriangle.c3b1e970.svg";